import * as tf from '@tensorflow/tfjs'; // Для браузера или Node.js с tfjs-node
import Tokenizer from './Tokenizer';

// Указываем полный URL к model.json (TensorFlow сам найдёт weights.bin в той же папке)
const modelUrl = '/model/model.json'; // замените на ваш URL

let model: tf.LayersModel | null = null;

// Загрузка модели с удалённого сервера
async function loadModel() {
  try {
    if (!model) {
      model = await tf.loadLayersModel(modelUrl);
      console.log("Модель успешно загружена.");
    }
    return model;
  } catch (error) {
    console.error("Ошибка при загрузке модели:", error);
    throw error;
  }
}

// Прогнозирование
export async function predict(text: string) {
  try {
    const model = await loadModel(); // Загружаем модель

    const tokenizer = new Tokenizer();
    const X = tokenizer.textToVector([text]);
    const X_tensor = tf.tensor(X);

    const prediction = model.predict(X_tensor) as tf.Tensor;
    const result = await prediction.data();

    console.log(`Оценка осмысленности: ${result[0]}`);
    return Number(result[0])
  } catch (error) {
    console.error("Ошибка при предсказании:", error);
  }
}
